import React from "react";
import withAdminContext from "../../store/withAdminContext";
import { Outlet } from "react-router-dom";

export const Appointments = ({ context: { state } }) => {
  return (<Outlet />);
}

export default withAdminContext(Appointments);